import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  filter,
  Subject,
  takeUntil,
  debounceTime,
  switchMap,
  Observable,
  of,
} from 'rxjs';
import { SuggestionsTagsInputOptions } from '@usitsdasdesign/dds-ng/suggestions-tags-input';
import {
  ArchiveDetailsExtendedModel,
  ArchiveDetailsModel,
  ArchiveDetailsResponseModel,
  WbsArchiveReceivedModel,
  WbsChargeCodeDetailsModel,
  wbsChargeCodeRequestModel,
  WbsResponseModel,
  WbsWithArchiveDetailsModelForGlobalEngagements,
} from '../../../common/models/wbs-picker.model';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';

import { ProgressIndicatorService } from '../../../common/services/progress-indicator.service';
import { Size, SpinnerThemes } from '@usitsdasdesign/dds-ng/shared';
import { HttpErrorResponse } from '@angular/common/http';
import { PermissionsObj } from '../../../common/models/common-models';
import {
  copyToClipboard,
  setArchiveDetails,
} from '../../../intake/common/intake.util';
import { GlobalEngagementsConstant } from '../../constants/global-engagements.constants';
import { CloseOutService } from '../../../http/intake/close-out.service';
import {
  INPUT_SEARCH_OPTIONS,
  selectOptionsArchive,
} from '../../../common/constants/common-helper';
import { SpinnerOptions } from '@usitsdasdesign/dds-ng/spinner';
import { SearchOptions } from '@usitsdasdesign/dds-ng/search';
import { GlobalEngagementSubmissionDetailModel } from '../../../common/models/global-engagement.model';
import { SharedConstant } from '../../../common/constants/shared.constant';
enum CallFromEnum {
  fromInit = 0,
  fromScroll = 1,
}
@Component({
  selector: 'app-global-engagement-wbs',
  templateUrl: './global-engagement-wbs.component.html',
  styleUrl: './global-engagement-wbs.component.less',
})
export class GlobalEngagementWbsComponent implements OnInit, OnDestroy {
  _EMPTY: string = GlobalEngagementsConstant.EMPTY_STRING;
  pageNumber: number = 0;
  totalCount: number = 0;
  paginationSize: number = GlobalEngagementsConstant.PAGE_NUMBER;
  onScrollDataLoadInProgress: boolean = false;
  totalSearchResultLoaded: number = 0;

  constructor(
    private readonly closeoutService: CloseOutService,
    private readonly progressIndicator: ProgressIndicatorService,
    private readonly _cdr: ChangeDetectorRef
  ) {}
  @Input() set submissionData(
    data: GlobalEngagementSubmissionDetailModel | null
  ) {
    if (data) {
      this.dataSubmissionId = data.submissionId;
      this.chargeCode = data.chargeCode ?? this._EMPTY;
      this.wbsDescription = data.wbsDescription ?? this._EMPTY;
      this.archiveDescription = this.setFetchedArchiveDetails(data);

      this.selectedArchive = data?.archiveNumber ?? this._EMPTY;
      this.showWbsEditOptions();
    }
  }
  @Input() permissionObj: PermissionsObj = {} as PermissionsObj;
  @Input() isSubmissionStatusDraft: boolean = false;
  @Output()
  wbsOrArchiveChange: EventEmitter<WbsWithArchiveDetailsModelForGlobalEngagements> =
    new EventEmitter<WbsWithArchiveDetailsModelForGlobalEngagements>();
  @Output()
  isWbsArchiveEditProgress: EventEmitter<boolean> = new EventEmitter<boolean>();

  wbsDescription: string = this._EMPTY;
  dataSubmissionId: number | null = null;
  wbsPendingCheckbox: boolean = false;
  private readonly searchWbsQuery$: Subject<string> = new Subject<string>();

  readonly #unsubscriber$: Subject<void> = new Subject<void>();
  archive: WbsArchiveReceivedModel | null = null;
  showEditWbsChargeCode: boolean = false;
  reloadWbsChargeCode: boolean = true;
  searchList: string[] = [];
  options: SuggestionsTagsInputOptions = INPUT_SEARCH_OPTIONS;
  wbsObjectArray: WbsChargeCodeDetailsModel[] = [];
  archiveSelectOptions = selectOptionsArchive;
  selectedArchive: string = this._EMPTY;
  wbsInputDisabled: boolean = false;
  actionDropdownList: SelectItemOptions[] = [];
  dropdownListData!: ArchiveDetailsResponseModel;
  wbsWarning: boolean = true;
  showArchiveDropdown: boolean = false;
  archiveDescription: string = this._EMPTY;
  checkboxThemeColor: string = GlobalEngagementsConstant.THEME_GREEN;
  emptyString: string = this._EMPTY;
  defaultForEmptyFields: string = GlobalEngagementsConstant.DEFAULT_VALUE;
  showDropdown: boolean = false;
  notFound: string = this._EMPTY;
  number_11: number = 11;
  isSpinnerVisible: boolean = false;
  isArchiveError: boolean = false;
  chargeCode = this._EMPTY;

  spinnerOptions: SpinnerOptions = {
    theme: SpinnerThemes.gray,
    thickness: '0.188rem',
    size: '1.875rem',
    customClass: this._EMPTY,
    isInverse: false,
  };

  searchOptions: SearchOptions = {
    placeholder: 'Search WBS',
    size: Size.md,
    customClass: this.emptyString,
  };

  ngOnInit(): void {
    this.showWbsEditOptions();
    this.searchWbsQuery$
      .pipe(
        debounceTime(GlobalEngagementsConstant.SEARCH_DEBOUNCE_TIME),
        filter(
          (key: string) =>
            !!key && key.length >= GlobalEngagementsConstant.SEARCH_LIMIT
        ),
        switchMap(() => this.fetchWbsDetails()),
        takeUntil(this.#unsubscriber$)
      )
      .subscribe({
        next: (response: WbsResponseModel) => {
          this.totalCount = response.totalCount;
          this.postWbsFetch(response);
        },
        error: (error: HttpErrorResponse) => {
          this.isSpinnerVisible = false;
          console.error('error', error);
        },
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isArchiveError= false;
    this.showWbsEditOptions();
  }

  postWbsFetch(response: WbsResponseModel): void {
    if (response) {
      this.wbsObjectArray = response.wbsChargeCodeDetails;
      if (this.totalCount === 0 && this.chargeCode !== this._EMPTY) {
        this.showDropdown = true;
        this.notFound = GlobalEngagementsConstant.NO_MATCHES_FOUND;
      } else if (this.totalCount > 0) {
        const result: string[] = response.wbsChargeCodeDetails?.map(
          (wbs) => wbs.wbsChargeCode
        );
        if (result) {
          this.searchList.push(...result);
          this.totalSearchResultLoaded = this.searchList.length;
        }
        this.notFound = this._EMPTY;
        this.showDropdown = true;
      }
      if (this.chargeCode !== this._EMPTY) {
        this.showDropdown = true;
      }
      this.isSpinnerVisible = false;
      this.onScrollDataLoadInProgress = false;
    }
  }

  showWbsEditOptions(): void {
    this.isWbsArchiveEditedProgress();
    if (
      this.chargeCode !== this._EMPTY &&
      this.chargeCode !== null &&
      this.chargeCode !== undefined
    ) {
      this.showEditWbsChargeCode = false;
    } else {
      this.showEditWbsChargeCode = true;
    }

    if (
      this.selectedArchive !== this._EMPTY &&
      this.selectedArchive !== null &&
      this.selectedArchive !== undefined
    ) {
      this.showArchiveDropdown = false;
    } else {
      this.showArchiveDropdown = true;
    }   
    
  }

  clipboardCopy(): void {
    if (this.chargeCode != null && this.chargeCode !== this._EMPTY) {
      copyToClipboard(this.chargeCode);
    }
  }

  editWBSChargeCode(): void {
    this.chargeCode = this._EMPTY;
    this.wbsDescription = this._EMPTY;
    this.wbsPendingCheckbox = false;
    this.showEditWbsChargeCode = true;
    this.selectedArchive = this._EMPTY;
    this.showArchiveDropdown = false;
    this.archiveDescription = this._EMPTY;
    this.showArchiveDropdown = true;
    this.wbsWarning = true;
    this.isWbsArchiveEditedProgress();
  }

  fetchWbsDetails(): Observable<WbsResponseModel> {
    const requestBody: wbsChargeCodeRequestModel = this.createRequestBody();
    this.isSpinnerVisible = true;   
    return this.closeoutService.getWbsChargeCodes(requestBody);
  }

  fetchWbsChargeCode(callfrom: number): void {
    const result = this.fetchWbsDetails();
    if (callfrom === CallFromEnum.fromScroll) {
      this.onScrollDataLoadInProgress = true;
      result.pipe(takeUntil(this.#unsubscriber$)).subscribe({
        next: (response: WbsResponseModel) => {
          this.postWbsFetch(response);
        },
        error: (error: HttpErrorResponse) => {
          this.isSpinnerVisible = false;
          console.error('error', error);
        },
      });
    }
  }

  onWbsChangeValue(): void {
    this.isArchiveError = false;
    if (this.isElementInArray(this.chargeCode, this.searchList)) {
      const selectedWBSCode: WbsChargeCodeDetailsModel | undefined =
        this.wbsObjectArray.find(
          (wbs: WbsChargeCodeDetailsModel) =>
            wbs.wbsChargeCode === this.chargeCode
        );
      if (selectedWBSCode) {
        this.wbsDescription = selectedWBSCode?.wbsDescription;
        this.chargeCode = selectedWBSCode?.wbsChargeCode;
        this.wbsWarning = false;
        this.showEditWbsChargeCode = false;
        this.selectedArchive = this._EMPTY;
        this.showArchiveDropdown = false;
        this.archiveDescription = this._EMPTY;
        this.updateWbsValues();
        this.fetchArchiveDropDownData();
        this.showArchiveDropdown = true;
        this.isWbsArchiveEditedProgress();
      }
    } else {
      if (
        this.chargeCode?.trim().length >= GlobalEngagementsConstant.SEARCH_LIMIT
      ) {
        this.fetchWbsChargeCode(
          GlobalEngagementsConstant.SEARCH_STRING_LIMIT_2
        );
      }
    }
  }

  onWbsChargeCodeSelect(event: string): void {
    this.showDropdown = false;
    this.chargeCode = event;
    this.onWbsChangeValue();
  }

  updateWbsValues(): void {
    let wbsWithArchiveDetails: WbsWithArchiveDetailsModelForGlobalEngagements =
      {
        ...setArchiveDetails(this._EMPTY, []),
        chargeCode: this.chargeCode,
        wbsDescription: this.wbsDescription,
      };
    this.wbsOrArchiveChange.emit(wbsWithArchiveDetails);
  }

  isElementInArray(element: string | null, array: string[]): boolean {
    if (element) {
      return array.includes(element);
    } else {
      return false;
    }
  }

  onArchiveSelect(): void {
    this.showArchiveDropdown = false;
    this.isWbsArchiveEditedProgress();
    const selectedArchiveDetails = this.dropdownListData.archiveDetails.find(
      (item: ArchiveDetailsModel) => item.archiveNumber === this.selectedArchive
    );
    this.progressIndicator.show();
    this.archiveDescription =
      selectedArchiveDetails?.archiveNumber +
      ' ' +
      selectedArchiveDetails?.archiveName;
    this.closeoutService
      .postGetArchiveDetails(this.selectedArchive)
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: ArchiveDetailsExtendedModel) => {
          if (response) {
            const wbsWithArchiveDetails: WbsWithArchiveDetailsModelForGlobalEngagements =
              {
                archiveNumber:
                  selectedArchiveDetails?.archiveNumber ?? this._EMPTY,
                archiveName: selectedArchiveDetails?.archiveName ?? this._EMPTY,
                archiveID: selectedArchiveDetails?.archiveID ?? this._EMPTY,
                archiveFolder:
                  selectedArchiveDetails?.archiveFolder ?? this._EMPTY,
                archiveFoldersArray:
                  selectedArchiveDetails?.archiveFoldersArray ?? [],
                clientName: selectedArchiveDetails?.clientName ?? this._EMPTY,
                clientNumber:
                  selectedArchiveDetails?.clientNumber ?? this._EMPTY,
                partner: selectedArchiveDetails?.partner ?? this._EMPTY,
                business: selectedArchiveDetails?.business ?? this._EMPTY,
                archiveDescription:
                  response.archiveDescription &&
                  response.archiveDescription !== null &&
                  response.archiveDescription != this._EMPTY
                    ? response.archiveDescription
                    : this.archiveDescription,
                archiveStatus: response.archiveStatus,
                chargeCode: this.chargeCode,
                wbsDescription: this.wbsDescription,
              };

            wbsWithArchiveDetails.chargeCode = this.chargeCode;

            wbsWithArchiveDetails.wbsDescription = this.wbsDescription;
            this.wbsOrArchiveChange.emit(wbsWithArchiveDetails);
          }
          this.progressIndicator.hide();
        },
        error: (error: HttpErrorResponse) => {
          this.progressIndicator.hide();
          console.error('error', error);
        },
      });
  }

  fetchArchiveDropDownData(): void {  
    if(this.chargeCode !== this._EMPTY) {
      this.actionDropdownList = [];
      this.progressIndicator.show();
    this.closeoutService
      .postSearchArchiveByWbs(this.chargeCode)
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: ArchiveDetailsResponseModel) => {
          if (response) {
            this.dropdownListData = response;
            this.progressIndicator.hide();
            this.actionDropdownList = this.dropdownListData.archiveDetails.map(
              (item: ArchiveDetailsModel) => {
                return {
                  heading: item.archiveNumber + ' ' + item.archiveName,
                  value: item.archiveNumber,
                };
              }
            );
            this._cdr.detectChanges();
          }
        },
        error: (error: HttpErrorResponse) => {
          this.progressIndicator.hide();
          this.isArchiveError = true;
          console.error('error', error, error.status);
        },
      });
    }
  }

  editArchiveDetails(): void {
    this.showArchiveDropdown = true;
    this.selectedArchive= this._EMPTY;
    this.isWbsArchiveEditedProgress();
    this.fetchArchiveDropDownData();
  }

  showDescriptionAndArchive(): boolean {
    return (
      (this.chargeCode !== this._EMPTY || this.chargeCode !== null) &&
      !this.showEditWbsChargeCode
    );
  }

  createRequestBody(): wbsChargeCodeRequestModel {
    return {
      searchTerm: this.chargeCode,
      pageNumber: this.pageNumber,
      pageSize: this.paginationSize,
    };
  }

  fieldCleared(): void {
    this.chargeCode = this._EMPTY;
    this.showDropdown = false;
    this.notFound = this._EMPTY;
  }

  findWbsChargeCode(event: string) {
    if (event.length > SharedConstant.TEXT_MIN_LENGTH_2 && event !== this._EMPTY) {
      this.showDropdown = true;
      this.pageNumber = 0;
      this.isSpinnerVisible = true;
      this.searchList = [];
      this.wbsPendingCheckbox = false;
      this.searchWbsQuery$.next(event);
    } else {
      this.notFound = this._EMPTY;
      this.showDropdown = false;
    }
  }

  fetchMoreWbsResult(event: any): void {
    if (
      !this.onScrollDataLoadInProgress &&
      event.target.offsetHeight + event.target.scrollTop >=
        event.target.scrollHeight
    ) {
      if (this.totalSearchResultLoaded < this.totalCount) {
        this.pageNumber++;
        this.fetchWbsChargeCode(CallFromEnum.fromScroll);
      }
    }
  }

  setFetchedArchiveDetails(
    data: GlobalEngagementSubmissionDetailModel | null
  ): string {
    if (
      data?.archiveDescription &&
      data?.archiveDescription !== null &&
      data?.archiveDescription !== this._EMPTY
    ) {
      return data?.archiveDescription;
    } else if (
      data?.archiveNumber &&
      data?.archiveNumber !== null &&
      data?.archiveNumber !== this._EMPTY &&
      data?.archiveName &&
      data?.archiveName !== null &&
      data?.archiveName !== this._EMPTY
    ) {
      return data?.archiveNumber + ' ' + data?.archiveName;
    } else {
      this.showArchiveDropdown = true;
      this.fetchArchiveDropDownData();
      this.isWbsArchiveEditedProgress();
      return this._EMPTY;
    }
  }

  isWbsArchiveEditedProgress(): void {
    let isEdited: boolean =
      this.showArchiveDropdown || this.showEditWbsChargeCode;
    this.isWbsArchiveEditProgress.emit(isEdited);
  }

  ngOnDestroy(): void {
    this.#unsubscriber$.next();
    this.#unsubscriber$.complete();
  }
}
